import { useCentralStore } from "../store/Central";

/**
 * Hook to guard navigation when an upload is in progress.
 * Returns a function that checks if navigation should proceed.
 * Shows a confirmation dialog if upload is in progress.
 *
 * @returns Function that returns true if navigation should proceed, false otherwise
 */
export const useUploadGuard = () => {
	const uploadStatus = useCentralStore((state) => state.uploadStatus);
	const setUploadStatus = useCentralStore((state) => state.setUploadStatus);

	const checkNavigationAllowed = (): boolean => {
		if (uploadStatus === 'uploading') {
			const confirmed = window.confirm(
				'Ein Upload läuft. Möchten Sie wirklich die Seite verlassen? Der Upload wird abgebrochen.'
			);

			if (!confirmed) {
				return false;
			}

			// Reset upload status if user confirms
			setUploadStatus('idle');
		}

		return true;
	};

	return checkNavigationAllowed;
};
